/* global Modernizr, $ */

(function () {
  'use strict';
  window.addEventListener('load', function () {
    var forms = document.getElementsByClassName('needs-validation');
    var validation = Array.prototype.filter.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      }, false);
    });
  }, false);
})();

$(document).on('click', 'a.openModal', function(e){
  openModal($(this).attr('href'));
  e.preventDefault();
})

function openModal(url) {
  $('#modal').iziModal('destroy');
  $("#modal").iziModal({
    closeOnEscape: true,
    iframe: true,
    iframeHeight: 600,
    iframeURL: url,
    overlayClose: false
  }).iziModal('open');
}

function closeModal() {
  $('#modal').iziModal('close');
  var t = setTimeout(function(){
    $('#modal').iziModal('destroy');
  }, 1000);
}
